const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const formatFaultDate = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempEvaporadorSalida", headerName: "Temp Evaporador Salida", minWidth: 180, flex: 1 },
  { field: "tempEvaporadorEntrada", headerName: "Temp Evaporador Entrada", minWidth: 180, flex: 1 },
  { field: "presionDescargaComp1", headerName: "Presión Descarga Comp 1", minWidth: 200, flex: 1 },
  { field: "presionDescargaComp2", headerName: "Presión Descarga Comp 2", minWidth: 200, flex: 1 },
  { field: "sobrecalentamientoComp1", headerName: "Sobrecalentamiento Comp 1", minWidth: 200, flex: 1 },
  { field: "sobrecalentamientoComp2", headerName: "Sobrecalentamiento Comp 2", minWidth: 200, flex: 1 },
  { field: "tempSuccionComp1", headerName: "Temp Succión Comp 1", minWidth: 180, flex: 1 },
  { field: "tempSuccionComp2", headerName: "Temp Succión Comp 2", minWidth: 180, flex: 1 },
  { field: "presionSuccionComp1", headerName: "Presión Succión Comp 1", minWidth: 200, flex: 1 },
  { field: "presionSuccionComp2", headerName: "Presión Succión Comp 2", minWidth: 200, flex: 1 },
  { field: "velocidadVentiladorEC1", headerName: "Velocidad Ventilador EC C1", minWidth: 200, flex: 1 },
  { field: "velocidadVentiladorEC2", headerName: "Velocidad Ventilador EC C2", minWidth: 200, flex: 1 },
  { field: "condicionComp1", headerName: "Condición Actual Comp 1", minWidth: 200, flex: 1 },
  { field: "condicionComp2", headerName: "Condición Actual Comp 2", minWidth: 200, flex: 1 },
  { field: "leaderSecondaryComp1", headerName: "Leader/Secondary Comp 1", minWidth: 200, flex: 1 },
  { field: "leaderSecondaryComp2", headerName: "Leader/Secondary Comp 2", minWidth: 200, flex: 1 },
  { field: "interlockComp1", headerName: "Interlock Comp 1", minWidth: 150, flex: 1 },
  { field: "interlockComp2", headerName: "Interlock Comp 2", minWidth: 150, flex: 1 },
  { field: "statusMotorProtect1", headerName: "Status Motor Protect 1", minWidth: 200, flex: 1 },
  { field: "statusMotorProtect2", headerName: "Status Motor Protect 2", minWidth: 200, flex: 1 },
  { field: "swflujoaguaevap", headerName: "Switch Flujo Agual Helada", minWidth: 200, flex: 1 },
  { field: "encendidoComp1", headerName: "Encendido Compresor 1", minWidth: 200, flex: 1 },
  { field: "encendidoComp2", headerName: "Encendido Compresor 2", minWidth: 200, flex: 1 },
  { field: "activacionValvulaEXVC1", headerName: "Activación Válvula EXV C1", minWidth: 200, flex: 1 },
  { field: "activacionValvulaEXVC2", headerName: "Activación Válvula EXV C2", minWidth: 200, flex: 1 },
  { field: "ventilador1Cto1EC", headerName: "Ventilador 1 Circuito 1 EC", minWidth: 200, flex: 1 },
  { field: "ventilador2Cto1AC", headerName: "Ventilador 2 Circuito 1 AC", minWidth: 200, flex: 1 },
  { field: "ventilador1Cto2EC", headerName: "Ventilador 1 Circuito 2 EC", minWidth: 200, flex: 1 },
  { field: "ventilador2Cto2AC", headerName: "Ventilador 2 Circuito 2 AC", minWidth: 200, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 200, flex: 1 },
  { field: "numeroFalla1", headerName: "Número de Falla 1", minWidth: 250, flex: 1 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 200, flex: 1 },
  { field: "numeroFalla2", headerName: "Número de Falla 2", minWidth: 250, flex: 1 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 200, flex: 1 },
  { field: "numeroFalla3", headerName: "Número de Falla 3", minWidth: 250, flex: 1 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 200, flex: 1 },
  { field: "numeroFalla4", headerName: "Número de Falla 4", minWidth: 250, flex: 1 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 200, flex: 1 },
  { field: "numeroFalla5", headerName: "Número de Falla 5", minWidth: 250, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempEvaporadorSalida: row["Temp Evaporador Salida"],
  tempEvaporadorEntrada: row["Temp Evaprador Entrada"],
  presionDescargaComp1: row["Presion Descarga Comp 1"],
  presionDescargaComp2: row["Presion Descarga Comp 2"],
  sobrecalentamientoComp1: row["Sobrecalentamiento Comp 1"],
  sobrecalentamientoComp2: row["Sobrecalentamiento Comp 2"],
  tempSuccionComp1: row["Temp Succion Comp 1"],
  tempSuccionComp2: row["Temp Succion Comp 2"],
  presionSuccionComp1: row["Presion Succion Comp 1"],
  presionSuccionComp2: row["Presion Succion Comp 2"],
  velocidadVentiladorEC1: row["Porcentaje Velocidad Ventilador EC Circuito 1"],
  velocidadVentiladorEC2: row["Porcentaje Velocidad Ventilador EC Circuito 2"],
  condicionComp1: row["Condición Actual Comp 1"],
  condicionComp2: row["Condición Actual Comp 2"],
  leaderSecondaryComp1: row["Leader / Secondary Comp 1"],
  leaderSecondaryComp2: row["Leader / Secondary Comp 2"],
  interlockComp1: row["Interlock Comp 1"],
  interlockComp2: row["Interlock Comp  2"],
  statusMotorProtect1: row["Status MotorProtect 1"],
  statusMotorProtect2: row["Status MotorProtect 2"],
  swflujoaguaevap: row["Switch Flujo Agual Helada"],
  encendidoComp1: row["Encendido Compresor 1"],
  encendidoComp2: row["Encendido Compresor 2"],
  activacionValvulaEXVC1: row["Activacion Valvula EXV C1"],
  activacionValvulaEXVC2: row["Activacion Valvula EXV C2"],
  ventilador1Cto1EC: row["Ventilador 1 Cto. 1 EC"],
  ventilador2Cto1AC: row["Ventilador 2 Cto. 1 AC"],
  ventilador1Cto2EC: row["Ventilador 1 Cto. 2 EC"],
  ventilador2Cto2AC: row["Ventilador 2 Cto. 2 AC"],
  fechaFalla1: formatFaultDate(row["Fecha de Falla 1"]),
  numeroFalla1: row["Numero de Falla 1"],
  fechaFalla2: formatFaultDate(row["Fecha de Falla 2"]),
  numeroFalla2: row["Numero de Falla 2"],
  fechaFalla3: formatFaultDate(row["Fecha de Falla 3"]),
  numeroFalla3: row["Numero de Falla 3"],
  fechaFalla4: formatFaultDate(row["Fecha de Falla 4"]),
  numeroFalla4: row["Numero de Falla 4"],
  fechaFalla5: formatFaultDate(row["Fecha de Falla 5"]),
  numeroFalla5: row["Numero de Falla 5"],
});

export const fullServiceCoolingUnicoConsultaConfig = {
  title: "Full Service Cooling UNICO",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecoolingunico/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "Full Service Cooling UNICO",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};